import React, { useState, useEffect } from 'react'
import {
    ModalDescription,
    ModalContent,
    Button,
    Modal,
} from 'semantic-ui-react'

import FromAccess from './FromAccess'

import {themes} from '@/theme/context'
import { SecondaryButton } from '../../pages/main_page/components/style'
import { CustomModal } from './style'

export const FreeAccess = ({primaryColor}) => {
    const [open, setOpen] = useState(global.location.search.includes('freeAccess') || false)
    const [mode, setMode] = useState('start')
    const color = themes['fepo'].primaryColor

    useEffect(() => {
        //удаляю "?freeAccess" из адресной строки
        open && global.history.pushState("", document.title, global.location.pathname);
    }, [])

    return (
        <>
            <SecondaryButton
                basic
                floated='right'
                $color={color}
                onClick={() => {
                    setOpen(true)
                    global.ym && global.ym(4897120, 'reachGoal', 'open_free_access')
                }}
            >Бесплатный доступ</SecondaryButton>
            <CustomModal
                onClose={() => {
                    setOpen(false)
                    setMode('start')
                }}
                onOpen={() => setOpen(true)}
                open={open}
                size='tiny'
                dimmer={{
                    style: {
                        backgroundColor: 'rgba(0, 0, 0, .3)'
                    }
                }}
                centered
                closeIcon
            >
                <ModalContent>
                    {mode == 'start' ? 
                    <ModalDescription style={{textAlign: 'center', fontSize: '.85rem'}}>
                        <p style={{color: color}}>Приветствуем <b>новых</b> будущих пользователей <br /> сервисов портала i-exam.ru</p>
                        
                        <p>
                            Если ваша образовательная организация еще не знакома
                            с системой интернет-тестирования для проведения
                            независимой оценки подготовки студентов,
                            то готовы предоставить <b>бесплатный доступ к одному из сервисов.</b>
                        </p>
                        <p>
                            В течение <b>14 дней</b> вы сможете оценить функционал
                            системы, возможности и достоинства выбранного сервиса,
                            самостоятельно организовав <b>50 сеансов тестирования.</b>
                        </p>
                        <p>
                            Заполните, пожалуйста, данные, чтобы создать
                            личный кабинет для дальнейшей работы.
                        </p>
                        <div style={{textAlign: 'center'}}>
                            <Button
                                content="Заполнить форму"
                                onClick={() => {
                                    setMode('form')
                                    global.ym && global.ym(4897120, 'reachGoal', 'open_free_access_form')
                                }}
                                positive
                                style={{fontSize: '.85rem'}}
                            />
                        </div>
                    </ModalDescription>
                    :
                    <ModalDescription style={{fontSize: '.85rem'}}>
                        <FromAccess />
                    </ModalDescription>
                    }
                </ModalContent>
            </CustomModal>
        </>
    );
}
